import cn from 'clsx'
// eslint-disable-next-line boundaries/element-types
import { Link } from '@muse-web/router'
import type { TPaginationProps } from './Pagination.types'
import { DOTS } from './helpers/constants'
import { getPaginationList } from './helpers/getPaginationList'
import styles from './Pagination.module.css'

export const Pagination = ({
    currentPage,
    lastPage,
    getPageHref,
    previousLabel = 'Previous',
    nextLabel = 'Next',
}: TPaginationProps) => {
    let dotsCount = 0
    const pages = getPaginationList(currentPage, lastPage).map(value => {
        if (value === DOTS) {
            dotsCount += 1
            return { value, key: `dots-${dotsCount}` }
        }
        return { value, key: String(value) }
    })

    return (
        <nav className={styles.nav}>
            {currentPage > 1 ? (
                <Link
                    href={getPageHref(currentPage - 1)}
                    className={cn(styles.item, styles['item-wide'])}
                >
                    {previousLabel}
                </Link>
            ) : null}

            <Link
                href={getPageHref(currentPage)}
                className={cn(styles.item, styles['item-active'], styles['mobile-only'])}
            >
                {currentPage}
            </Link>

            <span className={styles['desktop-only']}>
                {pages.map(({ value, key }) =>
                    value === DOTS ? (
                        <span className={styles.item} key={key}>
                            {DOTS}
                        </span>
                    ) : (
                        <Link
                            href={getPageHref(value)}
                            key={key}
                            className={cn(styles.item, {
                                [styles['item-active']]: value === currentPage,
                            })}
                        >
                            {value}
                        </Link>
                    ),
                )}
            </span>

            {currentPage < lastPage ? (
                <Link
                    href={getPageHref(currentPage + 1)}
                    className={cn(styles.item, styles['item-wide'])}
                >
                    {nextLabel}
                </Link>
            ) : null}
        </nav>
    )
}
